import React, { Component, useState } from 'react'
import SRCards from '../../components/SRCards'
import {
    Button, Container, FormControl, InputLabel, Select, MenuItem, Paper, TableContainer, TextField, Table,
    TableHead, TableRow, TableCell, TableBody, TableFooter,
    Dialog, DialogTitle, DialogContent, DialogActions, Snackbar, Typography
} from '@material-ui/core'
import { CheckBox } from '@material-ui/icons'
// const apiservices = new TicketApi();
// import './qbsync.css';
import CommonServiceApi from '../../services/common-service';
import { flatMap, map } from 'lodash';
import { Alert } from '@material-ui/lab';
import { CHECK_VALUE } from '../../common/data-validator';
import SelectCompany from '../../components/SelectCompany';

export default function QBSyncList() {
    const [entitySchema, setEntitySchema] = useState('');
    const [entityIds, setEntityIds] = useState([]);
    const [keys, setKeys] = useState('');
    const [dialog, setDialog] = useState(false);
    const [snackBar, setSnackBar] = useState('');
    const [confirmMsg, setConfirmMsg] = useState('');
    const [pageResponse, setPageResponse] = useState('');
    const [errorDialog, setErrorDialog] = useState(false);
    const apiservices = new CommonServiceApi();
    const handleChange = (e: any) => {
        if (e.target.value === 1) {
            setEntitySchema('customer_details');
        }
        else if (e.target.value === 2) {
            setEntitySchema('ticket');
        }
        else if (e.target.value === 3) {
            setEntitySchema('invoice');
        }
        else if (e.target.value === 4) {
            setEntitySchema('payment_history');
        }
        else if (e.target.value === 5) {
            setEntitySchema('timecard');
        }
        else if (e.target.value === 6) {
            setEntitySchema('customer_qb');
        }
        else if (e.target.value === 7) {
            setEntitySchema('ticket_qb');
        }
        else if (e.target.value === 8) {
            setEntitySchema('invoice_qb');
        }
        else if (e.target.value === 9) {
            setEntitySchema('payment_qb');
        }
        else if (e.target.value === 10) {
            setEntitySchema('timecard_qb');
        }
        else if (e.target.value === 11) {
            setEntitySchema('class_qb');
        }
        else if (e.target.value === 12) {
            setEntitySchema('flatrate_qb');
        }
        else if (e.target.value === 13) {
            setEntitySchema('user_qb');
        }
        else if (e.target.value === 13) {
            setEntitySchema('salestax_rate_qb');
        }
        else if (e.target.value === 13) {
            setEntitySchema('salestax_code_qb');
        }
    }

    const confirm = (e: any) => {
        if (CHECK_VALUE(entitySchema) && CHECK_VALUE(entityIds) && CHECK_VALUE(keys)) {
            let res = `This operation will sync the data in the selected table in QB. Are you sure?`
            setDialog(true);
            setConfirmMsg(res);
        }
        else {
            setErrorDialog(true);
        }
        return
    }

    const cancel = () => {
        setDialog(false);
        setSnackBar('info');
        setPageResponse(`Sync Cancelled.`);
    }

    const sync = async () => {
        let companyId = localStorage.getItem('selectedCompanyId');
        let response = await apiservices.qbSync(companyId, entitySchema, entityIds, JSON.parse(keys));
        if (response && response.updated && response.updated.affectedRows>0) {
            setDialog(false);
            setSnackBar('success');
            setPageResponse("Synced Successfully.")
        }
        else {
            let msg;
            if(response && response.message && response.description) {
                msg = `Sync Failed: ${response.message} - ${response.description}`
            } else {
                msg = `Sync Failed.`
            }
            setDialog(false);
            setSnackBar('error');
            setPageResponse(msg);}
    }

    const onClose = () => {
        setErrorDialog(false)
    }

    const handleKeysToUpdate = (e: any) => {
        // let val = JSON.parse(e.target.value)
        setKeys(e.target.value);
    }

    const handleEntityIds = (e: any) => {
        let val = e.target.value;
        setEntityIds(val.split(',').map((str: any)=> Number(str)));
    }

    return (
        <>
            <SRCards />
            <Container>
                <SelectCompany/>
                <br /> <br />
                <Button className='qbsync_body'
                    onClick={confirm}
                    style={{ margin: 10 }}
                    variant='outlined'> Sync </Button>
                <br></br><br></br>
                <FormControl fullWidth className='qbsync_body'>
                    <InputLabel id="demo-simple-select-label">Entity Schema</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        // value={age}
                        label="Age"
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Customer Details</MenuItem>
                        <MenuItem value={2}>Ticket</MenuItem>
                        <MenuItem value={3}>Invoice</MenuItem>
                        <MenuItem value={4}>Payment History</MenuItem>
                        <MenuItem value={5}>Timecard</MenuItem>
                        <MenuItem value={6}>Customer QB</MenuItem>
                        <MenuItem value={7}>Ticket QB</MenuItem>
                        <MenuItem value={8}>Invoice QB</MenuItem>
                        <MenuItem value={9}>Payment QB</MenuItem>
                        <MenuItem value={10}>Timecard QB</MenuItem>
                        {/* <MenuItem value={11}>Class QB</MenuItem> */}
                        <MenuItem value={12}>Flatrate QB</MenuItem>
                        <MenuItem value={12}>User QB</MenuItem>
                        <MenuItem value={12}>Salestax Rate QB</MenuItem>
                        <MenuItem value={12}>Salestax Code QB</MenuItem>
                    </Select>
                </FormControl>
                <br /> <br /> <br /> <br />
                <TextField
                    fullWidth
                    id="outlined-textarea"
                    label="Entity Ids"
                    placeholder="all ids should be separated by comma(,)"
                    rows={4}
                    variant="filled"
                    onChange={handleEntityIds}
                />
                <br /> <br /> <br /> <br />
                <TextField
                    fullWidth
                    id="outlined-textarea"
                    label="Keys To Update"
                    placeholder="json value expected"
                    multiline
                    rows={4}
                    variant="filled"
                    onChange={handleKeysToUpdate}
                />
                <Dialog
                    open={dialog}
                    onClose={() => {
                        setDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {'Confirmation!'}
                    </DialogTitle>
                    <DialogContent>
                        {confirmMsg}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={
                                () => {
                                    setConfirmMsg('Processing...')
                                    sync()
                                }
                            }
                        >
                            Confirm
                        </Button>
                        <Button
                            onClick={
                                () => cancel()
                            }
                            autoFocus
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={errorDialog}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogContent>
                        Please complete information before syncing.
                    </DialogContent>
                    <Button onClick={onClose}>Ok</Button>
                </Dialog>
                <Snackbar
                    open={snackBar === '' ? false : true}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    autoHideDuration={6000}
                    onClose={() => {
                        setSnackBar('')
                    }}
                >
                    <Alert
                        severity={snackBar === 'error' ? 'error' : 'success'}
                        onClose={() => {
                            setSnackBar('')
                        }
                        }>
                        {pageResponse}
                    </Alert>
                </Snackbar>
            </Container>
        </>
    )
}
